export default "__VITE_ASSET__CwalM5bw__"